import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Text } from '../text/Text.js';

var Container = /*#__PURE__*/styled(Box).withConfig({
  displayName: "DiscountBadge__Container",
  componentId: "sc-125hkk9-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background-color: ", ";\n  box-shadow: 0 0 0 2px ", ",\n    0 0 0 4px ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background-color: ", ";\n  box-shadow: 0 0 0 2px ", ",\n    0 0 0 4px ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.deal;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.deal;
});
var formatDiscount = function (amount) {
  return Math.round(amount);
};
var getBadgeSize = function (variant) {
  if (variant === "md" || variant === "lg") return "60px";
  if (variant === "sm") return "48px";
  return ["48px", "60px"];
};
var getDiscountFontSize = function (variant) {
  if (variant === "md" || variant === "lg") return 3;
  if (variant === "sm") return 2;
  return [2, 3];
};
var getRrpFontSize = function (variant) {
  if (variant === "md" || variant === "lg") return "9px";
  if (variant === "sm") return "7px";
  return ["7px", "9px"];
};
var DiscountBadge = function (_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? "sm" : _b,
    amount = _a.amount,
    discountDisplay = _a.discountDisplay,
    className = _a.className,
    rest = __rest(_a, ["variant", "amount", "discountDisplay", "className"]);
  var badgeSize = getBadgeSize(variant);
  var showDollar = discountDisplay === "dollar_value";
  return React__default.createElement(Container, __assign({
    className: className,
    width: badgeSize,
    height: badgeSize
  }, rest), React__default.createElement(Text, {
    as: "span",
    fontSize: getDiscountFontSize(variant),
    letterSpacing: "tight",
    fontFamily: "heading",
    lineHeight: "none",
    color: "white",
    fontWeight: 700
  }, showDollar && "$", formatDiscount(amount), !showDollar && "%"), React__default.createElement(Text, {
    forwardedAs: "span",
    color: "white",
    letterSpacing: "wide",
    fontFamily: "heading",
    lineHeight: "none",
    fontSize: getRrpFontSize(variant),
    fontWeight: 700
  }, "OFF RRP"));
};
var templateObject_1;

export { DiscountBadge };
//# sourceMappingURL=DiscountBadge.js.map
